import * as AuditLogs from '../AuditLogs';
import * as Dynamo from '../DynamoTypes';

/**
 * Ceilings on the two free-text fields that get persisted onto an audit log and then re-served, in full, in the
 * profile activity feed — an unbounded string on the way in is unbounded response weight on the way out. Set well
 * clear of real usage rather than to any product requirement: across production, comments reach 3,126 characters
 * (p50 121, p99 1,034) and messages 3,876 outside a single 20,015-character paste (p50 254, p99 1,889).
 *
 * Shared so the input that enforces them and the schema that validates them cannot drift. Note these bound one
 * record; they are not a byte budget for the response, which still needs the read itself windowed or paginated.
 */
export const MAX_AUDIT_LOG_COMMENT_LENGTH = 5_000;
export const MAX_PROFILE_MESSAGE_LENGTH = 10_000;

export type QueryAuditLogsArgs = {
    /**
     * @deprecated use the path param instead
     */
    medicalProfileId?: string;
    auditLogTypes: AuditLogs.AuditLogTypes[];
};

export type QueryOrganizationEntityAuditLogsArgs = {
    auditLogTypes?: AuditLogs.AuditLogTypes[];
};

export type AuditLogListItem = Dynamo.AuditLog & {
    comments: AuditLogComment[];
    auditLogTitle: string;
};

export type QueryAuditLogsResponse = {
    auditLogs: AuditLogListItem[];
};

export type UnauthorizedAuditLogDetails = {
    status: 'unauthorized';
};

export type PartiallyInvalidAuditLogDetails = {
    status: 'partially-invalid';
    oldAuditLog: Dynamo.AuditLog;
    newAuditLog: Dynamo.AuditLog;
};

export type ValidAuditLogDetails = {
    status: 'valid';
    auditLog: Dynamo.AuditLog;
};

export type AuditLogDetails = (UnauthorizedAuditLogDetails | PartiallyInvalidAuditLogDetails | ValidAuditLogDetails) & {
    comments: AuditLogComment[];
    auditLogTitle: string;
};

export type AuditLogDetailsResponse = {
    auditLogDetails: AuditLogDetails;
};

export type ValidAuditLogComment = {
    status: 'valid';
    userId: string;
    comment: string;
    date: string;
    userFirstName: string;
    userLastName: string;
    userPreferredName: string | null;
    auditLogCommentId: string;
    auditLogId: string;
};

export type UserDeletedAuditLogComment = {
    status: 'user-deleted';
    date: string;
    auditLogId: string;
};

export type AuditLogComment = ValidAuditLogComment | UserDeletedAuditLogComment;

export type AddAuditLogCommentRequest = {
    comment: string;
};

export type AddProfileMessageAuditLogRequest = {
    type: 'profile-message';
    message: string;
};
